<app-page-header [title]="'Brand Details'" [subtitle]="'View details of the selected brand'"></app-page-header>
<div class="mb-5">
    <div class="flex gap-2 items-center mb-2">
        <img
                [src]="brand?.image?.content?.preview?.cloudfrontUrl || 'assets/images/no-image.png'"
                alt="Brand Logo"
                class="w-12 h-12 object-cover rounded-sm">
        <h2 class="text-xl">{{ brand?.name }}</h2>
    </div>
    <p><strong>ID:</strong> {{ brand?.id }}</p>
    <p><strong>Label:</strong> {{ brand?.label }}</p>
    <p><strong>Created By:</strong> {{ brand?.createdBy | roleName }}</p>
    <p><strong>Updated By:</strong> {{ brand?.updatedBy | roleName }}</p>
</div>
<div class="flex justify-between gap-2">
    <div>
        <p-button (click)="openEditDialog()" icon="pi pi-pencil" isAdmin label="Edit" text></p-button>
        <p-button (click)="confirmDelete()" icon="pi pi-trash" isAdmin label="Delete" severity="danger" text></p-button>
    </div>
    <p-button label="Back to Brands" icon="pi pi-arrow-left" routerLink="/brands"></p-button>
</div>

<!-- Update Dialog -->
<app-update-brand-dialog
        [(visible)]="displayUpdateDialog"
        [brand]="editableBrand"
        (brandUpdated)="reloadBrandDetails()"
></app-update-brand-dialog>
